import React from "react";
import Footer from "../components/utils/Footer";
import ownersList from "../components/carousel/ownersList";
import NavBar from "../components/utils/NavBar";
import PersonalCard from "../components/aboutUs/PersonalCard";
import { hands } from "../images";
const AboutUs = () => {
  return (
    <div className="h-[calc(100dvh)] w-full overscroll-contain overflow-x-hidden">
      <section className="bg-black">
        <NavBar />
        <section className="bg-primary ">
          <div className="gap-8 items-center py-8 px-4 mx-auto max-w-screen-2xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
            <img className="w-full " src={hands} alt="dashboard " />
            <div className="mt-4 md:mt-0">
              <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 ">
                Our Mission.
              </h2>
              <p className="mb-6  font-semibold md:text-lg">
At MSY Apparel, our mission is to infuse innovation and creativity by delivering new-age decoration that merges with style into every stitch and print with precision and flair. Our business is dedicated to providing top-notch service for all our customers. Through expert embroidery, screen printing, digital print, sublimation, and customization of promotional items, we strive to elevate the experience by delivering products that inspire confidence, performance, and style.  Balancing this commitment with a strong focus on providing new and fresh ideas has proven our brand stands out from the competition!

              </p>
            </div>
          </div>
        </section>
        <div className="py-8 px-4 mx-auto max-w-screen-2xl lg:py-16 lg:px-6 ">
          <div className="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">
            {ownersList.map((data, index) => {
              let evenOrOdd = (index += 0);
              let even = true;
              if (evenOrOdd % 2 === 0) {
                even = true;
              } else {
                even = false;
              }
              return (
                <PersonalCard
                  name={data.name}
                  summary={data.summary}
                  even={even}
                  personsTitle={data.personsTitle}
                />
              );
            })}
          </div>
        </div>
        <Footer />
      </section>
    </div>
  );
};

export default AboutUs;
//         <ServiceDescription
//           title={"Our mission."}
//           content={`
// At MSY Apparel, our mission is to infuse innovation and creativity by delivering new-age decoration that merges with style into every stitch and print with precision and flair. Our business is dedicated to providing top-notch service for all our customers. Through expert embroidery, screen printing, digital print, sublimation, and customization of promotional items, we strive to elevate the experience by delivering products that inspire confidence, performance, and style.  Balancing this commitment with a strong focus on providing new and fresh ideas has proven our brand stands out from the competition!`}
//         />{" "}
